import React, { FC } from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from 'src/constants/routes'

type Props = {
  className?: string
}

const Footer: FC<Props> = ({ className = 'footer' }) => {
  return (
    <footer className={className}>
      <div className={'container-fluid'}>
        <div className={'row'}>
          <div className={'col-12 text-center'}>
            <Link to={ROUTES.tos()} target={'_blank'}>
              利用規約
            </Link>
            &nbsp;/&nbsp;
            <a href={'https://www.cyberbuzz.co.jp/privacy'} target={'_blank'} rel="noopener noreferrer">
              プライバシーポリシー
            </a>
            &nbsp;/&nbsp;
            <a href={'https://www.cyberbuzz.co.jp/'} target={'_blank'} rel="noopener noreferrer">
              運営会社
            </a>
          </div>
        </div>
        <div className={'row'}>
          <div className={'col-12 text-center'}>Owgi &copy; CyberBuzz, Inc.</div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
